import React from 'react';
import { X } from 'lucide-react';

const UseCaseModal = ({ isOpen, onClose, modalContent }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 overflow-y-auto">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto relative">
        <div className="sticky top-0 bg-white p-4 border-b flex justify-between items-center z-20">
          <h2 className="text-2xl font-bold">{modalContent.title}</h2>
          <button 
            onClick={onClose} 
            className="p-2 rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Close modal"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        <div className="p-6">
          {modalContent.content}
        </div>
      </div>
    </div>
  );
};

export default UseCaseModal;